import Vue from 'vue';
import Vuex from 'vuex';

import { loginWithEmailAndPassword, logout, createUser, forgotPassword, changePassword, fetchUserData, fetchReleaseData, fetchPaymentHistory } from '../utils/auth';

Vue.use(Vuex);

const store = new Vuex.Store({
  actions: {
    login({ dispatch, commit }, { email, password }) {
      return loginWithEmailAndPassword(email, password);
    },
    logout({ dispatch, commit }) {
      return logout();
    },
    createUser({ dispatch, commit }, { email, firstName, lastName }) {
      return createUser(email, firstName, lastName);
    },
    forgotPassword({ dispatch, commit }, { email }) {
      return forgotPassword(email);
    },
    changePassword({ dispatch, commit }, { authorizer, newPassword, newPasswordConfirm }) {
      return changePassword(authorizer, newPassword, newPasswordConfirm);
    },
    fetchUserData() {
      return fetchUserData();
    },
    fetchReleaseData({ dispatch }, { name, version, platform, channel }) {
      return fetchReleaseData(name, version, platform, channel);
    },
    fetchPaymentHistory() {
      return fetchPaymentHistory();
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js